import React, { createContext, useContext, useState } from "react";
import { ISearchResult } from "../models/ISearchResult";

export const SearchContext = createContext<any>({results: [], showResults: false, selected: null, isLoading: false, hasError: false});

export const useSearchContext = () => useContext(SearchContext);

export default function SearchProvider({ children }) {
    const [results, setResults] = useState<ISearchResult[]>([]);
    const [debouncedSearchValue, setDebouncedSearchValue] = useState<string>('');
    const [showResults, setShowResults] = useState(false);
    const [{ hasError, selected, isLoading }, setStatus] = useState({
        selected: null,
        isLoading: false,
        hasError: false,
    });

    return (
        <SearchContext.Provider value={{results, setResults, showResults, setShowResults, setStatus, selected, isLoading, hasError, debouncedSearchValue, setDebouncedSearchValue}}>
            {children}
        </SearchContext.Provider>
    );
}